import {
  Card,
  FormHelperText,
  Grid,
  InputLabel,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputField from "../../../../common/InputField";
import "./CareDirective.scss";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../../common/Buttons";
import {
  setCareDirectiveData,
  getCareDirectiveData,
  id,
} from "../../../../services/documentServices";
import { toast } from "react-hot-toast";
import { getKeyFromText, setStepStatus } from "../../../../utils/Utilities";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Other = ({ next, setButtonDisabled }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState({
    sleepHabit: "",
    music: "",
    hobby: "",
    contactLike: "",
    religionDescription: "",
  });

  const validate = Yup.object({
    sleepHabit: Yup.string().nullable(),
    music: Yup.string().nullable(),
    hobby: Yup.string().nullable(),
    contactLike: Yup.string().nullable(),
    religionDescription: Yup.string().nullable(),
  });

  const handleSubmit = async (values) => {
    setButtonDisabled(true);
    const { stepStatus, careDirectiveId, otherCareDirectiveId, ...rest } =
      values;
    const payload = {
      ...data,
      otherCareDirective: {
        ...rest,
        careDirectiveId,
        otherCareDirectiveId,
        stepStatus: setStepStatus("00-00-0000", { ...rest }),
      },
    };
    const result = await setCareDirectiveData(payload, id);
    if (result?.success) {
      next();
    }
    setButtonDisabled(false);
  };

  const getCareDirectiveDataFun = async () => {
    setButtonDisabled(true);
    const result = await getCareDirectiveData(id);
    if (result?.success && result?.payLoad) {
      setData(result.payLoad);
      if (result.payLoad.otherCareDirective !== null) {
        setInitialValues(result.payLoad.otherCareDirective);
      }
    }
    setButtonDisabled(false);
  };

  useEffect(() => {
    getCareDirectiveDataFun();
  }, []);

  return (
    <Card className="care-directive documents-card-height summary-table">
      <Grid container>
        <Grid item lg={7} md={6} sm={12} xs={12} className="outer outer-pt-10">
          <Typography>{t("others")}</Typography>
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validate}
            onSubmit={(values) => handleSubmit(values)}
          >
            {(formik) => (
              <Form id="form_submit" onSubmit={formik.handleSubmit}>
                <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                  {t("cd-o-text-1")}
                </FormHelperText>
                <InputField
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  name="sleepHabit"
                  type="text"
                />
                <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                  {t("cd-o-text-2")}
                </FormHelperText>
                <InputField
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  name="music"
                  type="text"
                />
                <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                  {t("cd-o-text-3")}
                </FormHelperText>
                <InputField
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  name="hobby"
                  type="text"
                />
                <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                  {t("cd-o-text-4")}
                </FormHelperText>
                <InputField
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  name="contactLike"
                  type="text"
                />
                <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                  {t("cd-o-text-5")}
                </FormHelperText>
                <InputField
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  name="religionDescription"
                  type="text"
                />
              </Form>
            )}
          </Formik>
        </Grid>
      </Grid>
    </Card>
  );
};

export default Other;
